<template>
  <div class="content">
    <section v-if="details != ''" class="info">
      <h2>基本信息</h2>
      <ul>
        <li>
          <label>公司：</label>
          <p>{{ details.company_name }}</p>
        </li>
        <br />
        <li>
          <label>类型：</label>
          <p v-show="details.type == 1">入帐</p>
          <p v-show="details.type == 2">出账</p>
        </li>
        <br />
        <li>
          <label>{{ details.type == 1 ? "入帐日期：" : "出账日期：" }}</label>
          <p>
            {{
              details.flow_date == undefined
                ? ""
                : details.flow_date.substring(0, 10)
            }}
          </p>
        </li>
        <br />
        <li>
          <label>{{ details.type == 1 ? "入帐金额：" : "出账金额：" }}</label>
          <p>{{ Number(details.amount) + "元" }}</p>
        </li>
      </ul>
      <div class="cancellation" v-show="details.status == 100">
        <img src="../../assets/money/zuofei.png" alt="" />
      </div>
    </section>
    <section v-if="details != ''" class="info">
      <h2>费用信息</h2>
      <ul>
        <li>
          <label>费用所属日期：</label>
          <p>
            {{
              details.finance_date != undefined
                ? details.finance_date.substring(0, 10)
                : ""
            }}
          </p>
        </li>
        <li>
          <label>结算类型：</label>
          <p v-if="details.xf_type == 1">应收</p>
          <p v-else-if="details.xf_type == 2">应付</p>
          <p v-else>未知</p>
        </li>
        <li>
          <label>费用类型：</label>
          <p>{{ details.pname + "-" + details.finance_type_name }}</p>
        </li>
        <li>
          <label>费用名称：</label>
          <p>{{ details.name }}</p>
        </li>
        <br />
        <li style="width: 80%">
          <label>费用明细：</label>
          <p>{{ details.detail }}</p>
        </li>
        <br />
        <li v-show="details.status == 100">
          <label>作废原因：</label>
        </li>
        <br v-show="details.status == 100" />
        <li>
          <label>费用金额：</label>
          <p>{{ Number(details.amount) + "元" }}</p>
        </li>
        <li
          v-show="
            details.type == 1 && details.status != 20 && details.status != 20
          "
        >
          <label>开票金额：</label>
          <p>{{ Number(details.invoice_amount) + "元" }}</p>
        </li>
        <li v-show="details.status == 42 || details.status == 50">
          <label>已到帐金额：</label>
          <p>{{ Number(details.finance_flow_total) + "元" }}</p>
        </li>
        <li v-show="details.status == 42 || details.status == 50">
          <label>未到帐金额：</label>
          <p>
            {{
              // eslint-disable-next-line vue/no-parsing-error
              Number(details.finance_remaining_amount) < 0
                ? "0元"
                : Number(details.finance_remaining_amount) + "元"
            }}
          </p>
        </li>
        <li>
          <label>提交人员：</label>
          <p>{{ details.create_user_name }}</p>
        </li>
        <li>
          <label>项目：</label>
          <p>{{ details.project_name }}</p>
        </li>
        <li>
          <label>签约主体：</label>
          <p>{{ details.project_company_name }}</p>
        </li>
        <li>
          <label>客户名称：</label>
          <p>{{ details.customer_name }}</p>
        </li>
      </ul>
    </section>
    <section v-show="details.check_record_list != ''">
      <h2>费用审核信息</h2>
      <a-steps
        :current="activeStep"
        direction="vertical"
        class="auditStyle"
        size="small"
      >
        <a-step v-for="item in details.check_record_list" :key="item.id">
          <a-icon
            v-if="item.result_status == 1"
            slot="icon"
            type="check-circle"
            style="color: #67c23a"
          />
          <a-icon
            v-else-if="item.result_status == 2"
            slot="icon"
            type="exclamation-circle"
            style="color: #f56c6c"
          />
          <a-icon
            v-else
            type="question-circle"
            slot="icon"
            style="color: #e6a23c"
          />
          <template slot="title">
            <p v-show="item.to_status == 20">提交申请</p>
            <p v-show="item.to_status == 21">负责人驳回</p>
            <p v-show="item.to_status == 30">负责人审核通过</p>
            <p v-show="item.to_status == 31">财务驳回</p>
            <p v-show="details.type == 1 && item.to_status == 40">
              财务审核通过
            </p>
            <p
              v-show="
                details.type == 2 &&
                  item.to_status == 40 &&
                  details.finance_type_name != '预支'
              "
            >
              财务审核通过
            </p>
            <p
              v-show="
                details.type == 2 &&
                  item.to_status == 40 &&
                  details.finance_type_name == '预支'
              "
            >
              预支审核通过
            </p>
            <p v-show="details.type == 1 && item.to_status == 42">出账成功</p>
            <p v-show="details.type == 2 && item.to_status == 42">入账成功</p>
            <p v-show="item.to_status == 41">出纳驳回</p>
            <p v-show="item.to_status == 50">结算完成</p>
            <p v-show="item.to_status == 100">费用作废</p>
          </template>
          <div slot="description" class="description">
            <span>
              <label>{{
                item.to_status == 20 ? "申请人：" : "审核人："
              }}</label>
              <p>
                {{ item.user_name }}
              </p>
            </span>
            <span>
              <label>{{
                item.to_status == 20 ? "申请时间：" : "操作时间："
              }}</label>
              <p>{{ item.create_time }}</p>
            </span>
            <br v-show="item.to_status == 40" />
            <span v-show="item.result_status == 2">
              <label>驳回原因：</label>
              <p>{{ item.reason }}</p>
            </span>
            <span v-show="details.type == 1 && item.to_status == 40">
              <label>开票日期：</label>
              <p>
                {{
                  item.invoice_date == undefined
                    ? ""
                    : item.invoice_date.substring(0, 10)
                }}
              </p>
            </span>
            <br v-show="item.to_status == 50 || item.to_status == 42" />
            <span v-show="item.to_status == 50 || item.to_status == 42">
              <label>{{
                details.type == 1 ? "入职账户：" : "出账账户："
              }}</label>
              <p>{{ item.company_name }}</p>
            </span>
            <span v-show="item.to_status == 50 || item.to_status == 42">
              <label>{{
                details.type == 1 ? "入账金额：" : "出账金额："
              }}</label>
              <p>{{ Number(item.amount) + "元" }}</p>
            </span>
            <span v-show="item.to_status == 50 || item.to_status == 42">
              <label>备注：</label>
              <p>{{ item.remark }}</p>
            </span>
            <span v-show="details.type == 1 && item.to_status == 40">
              <label>开票金额：</label>
              <p>{{ Number(item.invoice_amount) + "元" }}</p>
            </span>
          </div>
        </a-step>
      </a-steps>
    </section>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      details: {},
      activeStep: 0,
      isStatusVal: "process",
      handleCostVal: {},
      showIsHandleCancel: false,
      reason: ""
    };
  },
  props: {
    detailsVal: {}
  },
  mounted() {
    if (this.detailsVal != undefined) {
      this.getDetails();
    }
  },
  watch: {
    detailsVal() {
      this.getDetails();
      // console.log(this.details);
    }
  },
  methods: {
    getDetails() {
      this.details = this.detailsVal;
      if (this.details.check_record_list != undefined) {
        this.activeStep = this.details.check_record_list.length;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  padding: 30px 3%;
  h2 {
    font-size: 16px;
    margin-bottom: 10px;
    font-weight: normal;
  }
  > .info {
    > ul {
      margin-bottom: 30px;
      // margin: 0 20px 30px;
      > li {
        margin-bottom: 10px;
        display: inline-block;
        width: 33.3%;
        label,
        p,
        span {
          font-size: 14px;
          line-height: 20px;
          display: inline-block;
          vertical-align: top;
          max-width: 80%;
        }
      }
      .expenditure {
        width: 50%;
        table {
          width: 100%;
          th,
          td {
            border: 1px solid #ccc;
            padding: 4px 10px;
          }
          th {
            background: #f0f2f5;
          }
        }
      }
    }
  }
  .auditList {
    > span {
      display: block;
      // margin-left: 20px;
      margin-bottom: 10px;
      p,
      label {
        font-size: 14px;
        line-height: 20px;
        display: inline-block;
      }
    }
  }
  //   width: 100%;
  //   td,
  //   th {
  //     border: 1px solid #ccc;
  //     font-size: 14px;
  //     padding: 4px 6px;
  //   }
  //   th {
  //     background: #eee;
  //   }
  // }
  .handleCost {
    margin-top: 30px;
  }
}
</style>
<style lang="less">
.info {
  position: relative;
  .cancellation {
    position: absolute;
    right: 100px;
    top: 20px;
    img {
      height: 80px;
    }
  }
}

.auditStyle {
  margin: 20px;
  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-tail::after {
    background-color: rgba(0, 0, 0, 0.45);
    // background-color: #67C23A;
  }
  .description {
    > span {
      margin-right: 20px;
      display: inline-block;
      p,
      label {
        display: inline-block;
      }
    }
  }
}
</style>
